var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-route-bar",class:{
    'c-route-bar--inactive': _vm.inactive,
    'c-route-bar--ov': _vm.mode === 'ov',
    'c-route-bar--train': _vm.mode === 'train',
    'c-route-bar--walk': _vm.mode === 'walk',
    'c-route-bar--start': _vm.mode === 'start',
    'c-route-bar--destination': _vm.mode === 'destination'
  },style:({
    width: _vm.width ? (_vm.width + "%") : null
  })},[(_vm.icon)?_c('div',{staticClass:"c-route-bar__icon"},[_c('o-icon',{attrs:{"icon":_vm.icon}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }